import type {
  Configuration,
  AuthenticationResult,
  IPublicClientApplication,
} from '@azure/msal-browser';

import { LogLevel, EventType } from '@azure/msal-browser';

import { CONFIG } from 'src/global-config';

// This function exists solely to make the setup unit-testable.
export function configureGlobalClient(client: IPublicClientApplication): void {
  // Default to using the first account if no account is active on page load
  if (!client.getActiveAccount() && client.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    client.setActiveAccount(client.getAllAccounts()[0]);
  }

  // Listen for sign-in event and set active account
  client.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
      const payload = <AuthenticationResult>event.payload;
      if (payload?.account) {
        client.setActiveAccount(payload.account);
      }
    }
  });

  client.enableAccountStorageEvents();
}

export function getGlobalConfig(): Configuration {
  return {
    auth: CONFIG.msal.auth,
    cache: {
      cacheLocation: 'localStorage',
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        loggerCallback: (level, message, containsPii) => {
          if (!containsPii) {
            console.log(`[${LogLevel[level]}] ${message}`);
          }
        },
      },
    },
  };
}
